import React from 'react';
import { CreditCardIcon, MailIcon, ShieldCheckIcon, TagIcon } from 'lucide-react';
import { checkoutUrl, price } from '../data/salesCopy';
const includes = [{
  icon: CreditCardIcon,
  label: 'Pagá con Mercado Pago'
}, {
  icon: TagIcon,
  label: 'Único pago'
}, {
  icon: MailIcon,
  label: 'Acceso inmediato vía mail'
}];
export function Pricing() {
  return <section id="comprar" className="bg-ink py-12 text-cream sm:py-24" aria-labelledby="oferta" data-id="element-103" data-mp="2jlpbwjw2vsmq">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-104" data-mp="1vw4kdcluzn1u">
        <div className="rounded-[1.75rem] bg-ink-soft p-6 text-center sm:rounded-[2.5rem] sm:p-12" data-id="element-105" data-mp="1rthwtnw80oag">
          <h2 id="oferta" className="font-display text-[1.7rem] font-semibold leading-tight sm:text-4xl" data-id="element-106" data-mp="25t94z8023agj">
            Emprendé haciendo uñas desde casa
          </h2>

          <ul className="mt-6 grid gap-2.5 text-left sm:mx-auto sm:mt-8 sm:w-fit" data-id="element-107" data-mp="3h74o0ru303d1">
            {includes.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2.5 text-[15px] text-cream/80" data-id="element-108" data-mp="3c81t407tfdis">
                <Icon aria-hidden="true" className="h-4 w-4 shrink-0 text-champagne" data-id="element-109" data-mp="3vz72a1ghsvrl" />
                {label}
              </li>)}
          </ul>

          <p className="mt-7 font-display text-xl italic text-champagne-light sm:mt-9 sm:text-2xl" data-id="element-110" data-mp="9si9s1gd8n2q">
            Mirá, aprendé, emprendé.
          </p>

          <div className="mt-7 border-t border-ink-line pt-7 sm:mt-9 sm:pt-9" data-id="element-111" data-mp="eqk2le3lg0re">
            <p className="text-[11px] uppercase tracking-overline text-cream/50" data-id="element-112" data-mp="3daa61s1jbt6q">
              Llevátelo hoy a solo
            </p>
            <p className="mt-3 font-display text-5xl font-semibold text-champagne-light sm:text-6xl" data-id="element-113" data-mp="3i5xwsbvo0uec">
              {price.today}
            </p>
          </div>

          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="mt-7 flex w-full items-center justify-center rounded-2xl bg-champagne px-6 py-4 text-center text-[15px] font-semibold uppercase leading-tight tracking-[0.06em] text-ink transition-[transform,background-color] duration-150 ease-soft hover:bg-champagne-light active:scale-[0.99] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-champagne sm:mt-9 sm:py-5 sm:text-base" data-id="element-114" data-mp="3rywtkh1bfr91">
            Quiero mi acceso ahora
          </a>

          <p className="mt-5 flex items-center justify-center gap-2 text-[13px] text-cream/55" data-id="element-115" data-mp="2w7l60thxu39h">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-champagne" data-id="element-116" data-mp="2w9xnl5jsabm0" />
            Garantía total de 7 días · Pago 100% seguro
          </p>
        </div>
      </div>
    </section>;
}